import {StyleSheet} from 'react-native';
import {
  backgroundColor,
  fontColor,
  fontSize,
  basicColor,
  borderRadiusSize,
} from './base.variable';

export const fill = StyleSheet.create({
  fillW: {
    width: '100%',
  },
  fillH: {
    height: '100%',
  },
  fill: {
    height: '100%',
    width: '100%',
  },
});

export const position = StyleSheet.create({
  rel: {
    position: 'relative',
  },
  abs: {
    position: 'absolute',
  },
});

export const overflow = StyleSheet.create({
  hidden: {
    overflow: 'hidden',
  },
});

export const flex = StyleSheet.create({
  flex: {
    display: 'flex',
  },
  col: {
    flexDirection: 'column',
  },
  row: {
    flexDirection: 'row',
  },
  start: {
    justifyContent: 'flex-start',
  },
  end: {
    justifyContent: 'flex-end',
  },
  alignEnd: {
    alignItems: 'flex-end',
  },
  centerByCol: {
    alignItems: 'center',
  },
  centerByRow: {
    justifyContent: 'center',
  },
  center: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  around: {
    justifyContent: 'space-around',
  },
  between: {
    justifyContent: 'space-between',
  },
  wrap: {
    flexWrap: 'wrap',
  },
  flex1: {
    flex: 1,
    ...overflow.hidden,
  },
  flex2: {
    flex: 2,
    ...overflow.hidden,
  },
  flex3: {
    flex: 3,
    ...overflow.hidden,
  },
  flex4: {
    flex: 4,
    ...overflow.hidden,
  },
  shrink0: {
    flexShrink: 0,
  },
});

export const font = StyleSheet.create({
  primary: {
    color: basicColor.primary,
  },
  red: {
    color: basicColor.red,
  },
  white: {
    color: basicColor.white,
  },
  main: {
    color: fontColor.main,
  },
  second: {
    color: fontColor.second,
  },
  accent: {
    color: fontColor.accent,
  },
  secAccent: {
    color: fontColor.secAccent,
  },
  /** 小号字体 */
  fs: {
    fontSize: fontSize.s,
  },
  /** 中号字体 */
  fm: {
    fontSize: fontSize.m,
  },
  /** 大号字体 */
  fl: {
    fontSize: fontSize.l,
  },
  /** 特大号字体 */
  fxl: {
    fontSize: fontSize.xl,
  },
  bold: {
    fontWeight: 'bold',
  },
  fontDin: {
    fontFamily: 'DIN-BLA',
  },
  fontAnybody: {
    fontFamily: 'Anybody',
  },
  fontInter: {
    fontFamily: 'Inter',
  },
  fontInterBold: {
    fontFamily: 'Inter-Bold',
  },
});

export const background = StyleSheet.create({
  primary: {
    backgroundColor: basicColor.primary,
  },
  red: {
    backgroundColor: basicColor.red,
  },
  white: {
    backgroundColor: basicColor.white,
  },
  main: {
    backgroundColor: backgroundColor.main,
  },
  second: {
    backgroundColor: backgroundColor.second,
  },
  accent: {
    backgroundColor: backgroundColor.accent,
  },
  secAccent: {
    backgroundColor: backgroundColor.secAccent,
  },
  lightGrey: {
    backgroundColor: backgroundColor.lightGrey,
  },
  grey: {
    backgroundColor: backgroundColor.grey,
  },
});

export const border = StyleSheet.create({
  primary: {
    borderColor: basicColor.primary,
  },
  red: {
    borderColor: basicColor.red,
  },
  dark: {
    borderColor: basicColor.dark,
  },
  white: {
    borderColor: basicColor.white,
  },
});

export const borderRadius = StyleSheet.create({
  xs: {
    borderRadius: borderRadiusSize.xs,
  },
  s: {
    borderRadius: borderRadiusSize.s,
  },
  m: {
    borderRadius: borderRadiusSize.m,
  },
  l: {
    borderRadius: borderRadiusSize.l,
  },
  xl: {
    borderRadius: borderRadiusSize.xl,
  },
});
